<template>
    <div class="main__learner__profile__page common__page__box">
        <div class="rlms-container">
            <section class="main__learner__profile__dashboard">
                <div class="left__learner__dashboard__box">
                    <section class="learner__profile__box">
                        <div class="learner__user__profile__box">
                            <div class="user__profile__img">
                                <img :src="learnerIcon">
                            </div>
                            <div class="user__info__box">
                                <div class="info__seprate__cover">
                                    <h3 class="name__title">{{ learner?.firstname }} {{ learner?.lastname }}</h3>
                                    <span
                                        v-if="learner?.subscriptions_details && !learner.subscriptions_details.is_expired"
                                        class="active__label">Active</span>
                                    <span
                                        v-else-if="learner?.subscriptions_details && learner.subscriptions_details.is_expired"
                                        class="inactive__label">Expired</span>
                                    <span v-else class="inactive__label">No Subscription</span>
                                    <div class="rlms-flex rlms-items-center rlms-flex-wrap rlms-gap-5"
                                        v-if="learner?.subscriptionid">
                                        <span class="rlms-fs-xxs"><b>Subscription End Date:</b></span>
                                        <label class="rlms-fs-xxs">{{
                                            formatDate(learner?.subscriptions_details?.end_date, 'D MMM YYYY hh:mm A')
                                        }}</label>
                                    </div>
                                    <div class="rlms-flex rlms-items-center rlms-flex-wrap  rlms-gap-5">
                                        <label class="rlms-fs-xxs"><b>Date of Birth:</b></label>
                                        <span class="rlms-fs-xxs">{{ formatDate(learner?.dob) }}</span>
                                    </div>
                                </div>
                                <div class="trans__dark__btn__box">
                                    <a href="javascript:void(0);" @click="accessWorkPacket">Access Work Packet</a>
                                </div>
                            </div>
                        </div>
                        <div class="user__personal__info">
                            <div class="info__box__wrapper" v-if="learner?.address">
                                <label class="label">Address</label>
                                <span class="location">{{ learner.address }}</span>
                            </div>

                        </div>
                        <div class="learner__edit__btn">
                            <a href="javascript:void(0)" @click="showEditLearnerModal = true"
                                v-if="learner?.is_owner || learner?.is_administrator">
                                <span class="btn__icon">
                                    <img :src="blueEdit">
                                </span>
                                <span class="btn__text">Edit Learner</span>
                            </a>
                        </div>
                    </section>

                    <div class="rlms-w-100" :class="{
                        'learners__assessment__widget': !isMobile,
                        'rlms-flex rlms-flex-col rlms-gap-30': isMobile
                    }">
                        <div class="head__title__wrap" :class="{
                            'rlms-flex rlms-flex-col rlms-gap-15': isMobile
                        }">
                            <h3 class="title">Results</h3>
                            <div class="title__btn__group rlms-justify-between">
                                <div class="recycle__bin__btn"
                                    v-if="(learner?.subscriptions_details && !learner?.subscriptions_details?.is_expired) && canConductAssessment">
                                    <a href="javascript:void(0);" v-if="learner?.bin_count > 0"
                                        @click="binAssessmentModal = true">
                                        <span class="btn__icon"><img :src="removeIcon1" /></span>
                                        <span class="btn__text">Recycle Bin</span>
                                    </a>
                                </div>
                                <div class="purple__fill__btn">
                                    <a href="javascript:void(0)" id="create_assessment"
                                        v-if="(learner?.subscriptions_details && !learner?.subscriptions_details?.is_expired) && canConductAssessment"
                                        @click="createAssessment">Create New
                                        Assessment</a>
                                </div>
                            </div>
                        </div>
                        <div class="divider__sepline" v-if="!isMobile"></div>
                        <template v-if="learner?.subscriptionid">
                            <template v-if="learner?.assessments?.length > 0">
                                <template v-if="isMobile">
                                    <div class="mobile__learners__assessment__widget for__mobile">
                                        <div class="mobile__learner__assessment__list__wrapper"
                                            v-for="(assessment) in learner?.assessments" :key="assessment.id">
                                            <div class="learner__assessment__box__item">
                                                <div class="learner__assessment__header">
                                                    <div class="date__assessment__label">
                                                        <span class="date__text">{{ formatDate(assessment?.created_at)
                                                            }}</span>
                                                        <span class="text">Assessment #{{ assessment?.serialno }}</span>
                                                    </div>
                                                    <div class="learner__user__progress__bar">
                                                        <div class="progress__bar__title">
                                                            <label class="progress__label"></label>
                                                            <span class="progress__percent">({{
                                                                assessment?.stats?.total_score
                                                                }}/100)</span>
                                                        </div>
                                                    </div>
                                                    <div class="learner__user__progress__bar">
                                                        <div class="progress__bar__title">
                                                            <label class="progress__label">Progress</label>
                                                            <span class="progress__percent">{{
                                                                assessment?.stats?.total_percentage }}%</span>
                                                        </div>
                                                        <div class="learner__progress">
                                                            <div class="default__progressbar">
                                                                <span class="progressbar__filler"
                                                                    :style="{ width: `${assessment?.stats?.total_percentage}%` }"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="divider__sepline"></div>
                                                <div class="learner__options__wrap">
                                                    <div class="link__btn">
                                                        <RouterLink
                                                            :to="`/organizations/${organizationId}/learners/${learnerId}/assessments/${assessment.id}`"
                                                            class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer">
                                                            <span class="link__icon">
                                                                <img :src="blueEdit">
                                                            </span>
                                                            <span class="link__text">Edit</span>
                                                        </RouterLink>
                                                    </div>
                                                    <div class="link__btn">
                                                        <a href="javascript:void(0)" class="delete_assessment"
                                                            @click="deleteAssessment(assessment.id, 0, assessment?.can_edit)">
                                                            <span class="link__icon"><img :src="blueTrash"></span>
                                                            <span class="link__text">Remove</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="learners__assessment__table__box__wrapper">
                                        <div class="head__title__box">
                                            <div class="head__title head__index__number">#</div>
                                            <div class="head__title head__date">Date</div>
                                            <div class="head__title head__score__assessment">Assessment Score</div>
                                            <div class="head__title head__progress">Completion Progress</div>
                                            <div class="head__title head__action">Action</div>
                                        </div>
                                        <div class="divider__sepline"></div>
                                        <div class="learners__assessment__card__box">
                                            <div class="learners__assessment__item"
                                                v-for="(assessment) in learner?.assessments" :key="assessment.id">
                                                <div class="learners__assessment__data learners__index__number">
                                                    <span class="index__number color1">{{ assessment?.serialno }}</span>
                                                </div>
                                                <div class="learners__assessment__data learners__date">
                                                    {{ formatDate(assessment?.created_at) }}
                                                </div>
                                                <div class="learners__assessment__data learners__score__assessment">
                                                    <span class="score__label">{{ assessment?.stats?.total_score
                                                    }}/100</span>
                                                </div>
                                                <AssessmentProgressBar
                                                    :overallProgress="assessment?.stats?.total_percentage"
                                                    :groups="assessment?.stats?.group_scores" />
                                                <div class="learners__assessment__data learners__action">
                                                    <div class="learners__btn__group">
                                                        <div class="action__default__btn">
                                                            <RouterLink
                                                                :to="`/organizations/${organizationId}/learners/${learnerId}/assessments/${assessment.id}`"
                                                                class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer">
                                                                <span class="btn__icon">
                                                                    <img :src="blueEdit">
                                                                </span>
                                                                <span class="btn__text">View</span>
                                                            </RouterLink>
                                                        </div>
                                                        <div class="action__default__btn">
                                                            <a href="javascript:void(0)" class="delete_assessment"
                                                                @click="deleteAssessment(assessment.id, 0, assessment?.can_edit)">
                                                                <span class="btn__icon"><img :src="blueTrash"></span>
                                                                <span class="btn__text">Remove</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <div class="assessment__view__all__btn">
                                    <div class="purple__solid__btn">
                                        <RouterLink
                                            :to="`/organizations/${learner.organization_id}/learners/${learner.id}/assessments`">
                                            View All</RouterLink>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="no__learner__assessment__block rlms-text-center">
                                    <div class="learner_assessment_delete_btn_wrapper rlms-mx-auto">
                                        <h3 class="title rlms-mb-3">You Have No Results Yet</h3>
                                        <div class="subtitle rlms-mb-3" v-if="learner?.bin_count > 0">
                                            Please click the below button for restore an assessment
                                        </div>
                                        <div class="ladb rlms-mx-auto"
                                            v-if="canConductAssessment && learner?.bin_count > 0"
                                            @click="binAssessmentModal = true" style="width: 140px;">
                                            <a href="javascript:void(0)" class="rlms-flex rlms-justify-between">
                                                <span class="btn__icon">
                                                    <img :src="removeIcon1" />
                                                </span>
                                                <span class="btn__text">Recycle Bin</span>
                                            </a>
                                        </div>
                                        <template v-else>
                                            <div class="subtitle rlms-mb-3">
                                                Please click the below button for adding the assessment
                                            </div>
                                            <div class="purple__fill__btn">
                                                <a href="javascript:void(0)" id="create_assessment"
                                                    v-if="(learner?.subscriptions_details && !learner?.subscriptions_details?.is_expired) && canConductAssessment"
                                                    @click="createAssessment">Create New
                                                    Assessment</a>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <div class="no__learner__assessment__block" v-else>
                            <div class="inner__content__block" v-if="learner">
                                <div class="title__block__wrap">
                                    <h4 class="title">
                                        {{ learner?.subscription_status == null ? `Learner Has No Subscription` :
                                            `Learner Subscription Has
                                        Expired` }}
                                    </h4>
                                    <span class="subtitle" v-if="learner?.subscription_status">
                                        Please click the below button for adding the Subscription
                                    </span>
                                    <span class="subtitle" v-else>
                                        {{ learner?.subscription_status == null ? `This learner has no subscription.` :
                                            `This learner has
                                        subscription has expired` }}
                                    </span>
                                </div>

                                <div class="purple__solid__btn" v-if="learner?.subscription_status">
                                    <RouterLink :to="`/organizations/${learner.organization_id}/overview`">
                                        View Organization
                                    </RouterLink>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- Tag Grid should always be visible, regressions flag only affects its behavior -->
                    <TagGridTable :tagGridData="tagGridData" />
                </div>
                <div class="right__learner__dashboard__box">
                    <div class="learner__progress__widget">
                        <div class="head__title__wrap">
                            <h3 class="title">Progress</h3>
                            <div class="title__select__box">
                                <select class="select" v-model="progressFilter" @change="fetchLearner">
                                    <option value="y">Last Yearly</option>
                                    <option value="m">Last Month</option>
                                    <option value="d">Last Days</option>
                                    <option value="a">All Time</option>
                                </select>
                            </div>
                        </div>
                        <div class="divider__sepline"></div>
                        <div class="chart__box__wrapper">
                            <div class="card">
                                <div class="percent">
                                    <svg>
                                        <circle cx="150" cy="150" r="100"></circle>
                                        <circle id="progressCover" cx="150" cy="150" r="100"
                                            :style="`--percent: ${organization?.stats?.percentageOfAttempted ?? 0}`">
                                        </circle>
                                    </svg>
                                    <div class="number">
                                        <h3 id="percentageNumber">{{ organization?.stats?.percentageOfAttempted ?? 0 }}%
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="learner__voice__widget">
                        <h3 class="title">Voice Bank</h3>
                        <div class="divider__sepline"></div>
                        <div class="view__voice__bank__btn">
                            <RouterLink
                                :to="{ name: 'LearnerVoiceBank', params: { organization: organizationId, learner: learnerId } }">
                                View Voice Bank
                            </RouterLink>
                        </div>
                    </div>
                    <div class="learner__tips__widget rlms-w-100" style="display: block;">
                        <!-- Slider main container -->
                        <Swiper :modules="modules" :slides-per-view="1" :space-between="50"
                            :pagination="{ clickable: true }" v-if="swiperReady">
                            <SwiperSlide class="test">
                                <div class="rlms-flex rlms-flex-col">
                                    <img :src="adsImg1" class="rlms-mx-auto" width="280" />
                                    <b>Features Coming Soon</b>
                                    <p class="rlms-fs-xs">The app is currently under development. Let us know what you
                                        think at datamtd.com/contact</p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide class="test">
                                <div class="rlms-flex rlms-flex-col">
                                    <img :src="adsImg1" class="rlms-mx-auto" width="280" />
                                    <b>Features Coming Soon</b>
                                    <p class="rlms-fs-xs">The app is currently under development. Let us know what you
                                        think at datamtd.com/contact</p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide class="test">
                                <div class="rlms-flex rlms-flex-col">
                                    <img :src="adsImg1" class="rlms-mx-auto" width="280" />
                                    <b>Features Coming Soon</b>
                                    <p class="rlms-fs-xs">The app is currently under development. Let us know what you
                                        think at datamtd.com/contact</p>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </section>
        </div>
    </div>

    <AddEditLearnerModal v-if="showEditLearnerModal" @close="showEditLearnerModal = false;"
        @saved="async () => { await init() }" :organizationId="organizationId" :learner="learner" />

    <BinAssessmentsModal v-if="binAssessmentModal" @close="binAssessmentModal = false;"
        @saved="async () => { await init() }" :organizationId="organizationId" :learnerId="learnerId" />
</template>
<script setup>
import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import api from "@/services/axios";
import AddEditLearnerModal from '@/components/AddEditLearnerModal.vue';
import confirmationIcon from '@/assets/images/confirmation.png';
import BinAssessmentsModal from '@/components/BinAssessmentsModal.vue';
import AssessmentProgressBar from '@/components/assesments/AssessmentProgressBar.vue';
import { showConfirmDialog, showDialog, showToast } from '@/utils/swal';
import { formatDate } from '@/utils/format-helpers';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
const modules = [Pagination];
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import TagGridTable from '@/components/assesments/TagGridTable.vue';
import { useLoaderStore } from '@/stores/loader';
import learnerIcon from '@/assets/images/learner-icon.png'
import blueEdit from '@/assets/images/see-icon.png'
import removeIcon1 from '@/assets/images/remove-icon1.png'
import adsImg1 from '@/assets/images/ads-img1.png'
import blueTrash from '@/assets/images/blue-trash.svg'
import { handleError } from '@/utils/handleError';
import { authrizedPermissions } from '@/utils/permissions';
const swiperReady = ref(false)

const router = useRouter();
const route = useRoute();

const organizationId = Number(route.params.organization ?? 0);
const learnerId = Number(route.params.learner ?? 0);
const organization = ref(null);
const learner = ref(null);
const tagGridData = ref(null);
const showEditLearnerModal = ref(false);
const assignSubModal = ref(false);
const binAssessmentModal = ref(false);
const progressFilter = ref('a');
const loader = useLoaderStore();

const screenWidth = ref(window.innerWidth);
const isMobile = computed(() => screenWidth.value < 768);
const updateWidth = () => {
    screenWidth.value = window.innerWidth;
};

onMounted(() => {
    window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
    window.removeEventListener('resize', updateWidth);
});


onMounted(async () => {
    await init();

    setTimeout(() => {
        swiperReady.value = true
    }, 300)
});

const init = async () => {
    showEditLearnerModal.value = false;
    assignSubModal.value = false;
    binAssessmentModal.value = false;
    await fetchLearner();
}

const fetchLearner = async () => {
    try {
        loader.show();
        const { data } = await api.get(`/organizations/${organizationId}/learners/${learnerId}`, { params: { with_tag_grid: 1, stats: progressFilter.value } });
        organization.value = data.data;
        learner.value = organization.value.learner;
        tagGridData.value = organization.value.tagGridData;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const createAssessment = async () => {
    try {
        loader.show();
        await api.post(`/organizations/${organizationId}/assessments`, {
            learner_id: learnerId
        });

        showToast({
            icon: 'success',
            title: 'Great! ',
            text: 'Assessment created successfully.',
        });

        await init();
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const deleteAssessment = async (assessment, status, canEdit = true) => {
    if (!canEdit) {
        let message = `You don’t have permission perform this action.`;

        if (learner.value?.is_administrator) {
            message = `You don’t have permission to move this assessment to the bin because it was created before you were granted administrator access.`;
        } else if (learner.value?.is_authorized_user) {
            if (learner.value?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `You don’t have permission to move this assessment to the bin because it was created before you were granted group access.`;
            } else if (!learner.value?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `Assessment available to you through group access. You don’t have permission perform this action.`;
            }
        }

        showDialog({ icon: 'warning', html: message });
        return;
    }

    const result = await showConfirmDialog({
        title: 'Are you sure?',
        html: '<p id="text-message">Are you sure?</p><span class="rlms-text-danger-500" id="delete-confirm"> Would you like to move this assessment to the recycle bin?</span>',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Confirm',
        imageUrl: confirmationIcon,
    });

    if (result.isConfirmed) {
        try {
            loader.show();

            await api.put(`/organizations/${organizationId}/assessments/${assessment}`, {
                status
            });

            showToast({
                icon: 'success',
                title: 'Deleted! ',
                text: 'Assessment moved to the recycle bin. You can restore it anytime.',
            });

            await init();
        } catch (error) {
            handleError(error);
        } finally {
            loader.hide();
        }
    }
};

const accessWorkPacket = () => {
    if (!learner?.value?.assessments?.length) {
        showDialog({
            icon: 'warning',
            html: 'Please create an assessment first before accessing the work packet.'
        });

        return;
    }

    router.push({ name: 'LearnerWorkpacket', params: { organization: organizationId, learner: learnerId } });

}

const canConductAssessment = computed(() => {
    return (learner.value?.is_owner || learner.value?.is_administrator ||
        (learner.value?.is_authorized_user && learner.value?.permissions?.[authrizedPermissions.conduct_view_assessments])
    )
});
</script>

<style>
.learner__tips__widget .swiper {
    height: 320px;
    border-radius: 20px;
    background: #fff;
}

.learner__tips__widget .swiper-slide {
    padding: 0;
    flex-direction: column !important;

    & img {
        width: 240px;
        margin: 0 auto;
    }

    & b {
        font-size: 20px;
        text-align: center;
        display: block;
        margin: 20px 0px;
    }

    & p {
        text-align: center;
    }
}

.swiper-slide {
    background: transparent;
}
</style>